/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


/* Product Description Tab */
document.addEventListener('click', function (event) {
  var tab = event.target.closest('[data-product-description-tabs] .product-description-tabs__tab');
  if (!tab) return;

  var tabsContainer = tab.closest('[data-product-description-tabs]');
  var panelId = tab.getAttribute('aria-controls');
  var panel = panelId ? document.getElementById(panelId) : null;
  if (!tabsContainer || !panel) return;

  tabsContainer.querySelectorAll('.product-description-tabs__tab').forEach(function (item) {
    item.classList.remove('is-active');
    item.setAttribute('aria-selected', 'false');
  });

  tabsContainer.querySelectorAll('.product-description-tabs__panel').forEach(function (item) {
    item.classList.remove('is-active');
    item.setAttribute('hidden', '');
  });

  tab.classList.add('is-active');
  tab.setAttribute('aria-selected', 'true');
  panel.classList.add('is-active');
  panel.removeAttribute('hidden');
});
